/* EVENTS INVOLVING DASHBOARDS */

function getDefaultDashboardProps({ dashboard }) {
  return {
    dashboardId: dashboard?.id,
    dashboardTitle: dashboard?.title,
  };
}

export default {
  dashboard_edit_visit: {
    // visit the editor
    excludeSuperAdmin: true,
    getProps: getDefaultDashboardProps,
  },
  dashboard_edit_close: {
    // close the editor
    excludeSuperAdmin: true,
    getProps: getDefaultDashboardProps,
  },
  dashboard_edit_widget_remove: {
    // remove a chart from the dashboard
    getProps: ({ chart, dashboard, account }) => {
      return {
        ...getDefaultDashboardProps({ dashboard }),
        widgetId: chart?.id,
        widgetTitle: chart?.title,
        widgetType: chart.type ? chart.type : 'chart',
        accountId: account?.id,
      };
    },
  },
  dashboard_share_edit_visit: {
    // visit the share modal
    excludeSuperAdmin: true,
    getProps: getDefaultDashboardProps,
  },
  dashboard_share_edit_close: {
    // close the share modal without saving
    excludeSuperAdmin: true,
    getProps: getDefaultDashboardProps,
  },
  dashboard_filter_visit: {
    // visit the filter menu
    excludeSuperAdmin: true,
    getProps: getDefaultDashboardProps,
  },
  dashboard_filter_on: {
    // going from 0 -> 1 filter option
    excludeSuperAdmin: true,
    getProps: getDefaultDashboardProps,
  },
  dashboard_edit_layout_change: {
    // click on the done button on dash edit page
    excludeSuperAdmin: true,
    getProps: getDefaultDashboardProps,
  },
  filter_panel_state_changed: {
    excludeSuperAdmin: true,
    getProps: ({ dashboard, new_state }) => {
      return {
        ...getDefaultDashboardProps({ dashboard }),
        new_state: new_state,
      };
    },
  },
  session_filter_modified: {
    excludeSuperAdmin: true,
    getProps: ({ dashboard, number_of_active_filters, filterSource }) => {
      return {
        ...getDefaultDashboardProps({ dashboard }),
        filter_source: filterSource,
        number_of_active_filters: number_of_active_filters,
      };
    },
  },
};
